module.exports = __webpack_public_path__ + "static/media/aux-mono.4323dce4.otf";